import React from 'react';
import {Button, CircularProgress} from '@mui/material';

interface StageExitActionProps {
  text?: string;
  color?: 'red' | 'yellow';
  onExit: () => void;
  loading?: boolean;
}

const StageExitAction: React.FC<StageExitActionProps> = ({text, color = 'red', onExit, loading}) => {
  const bgClass = color === 'red' ? 'bg-red-600 hover:bg-red-700' : 'bg-yellow-500 hover:bg-yellow-600';

  return (
      <Button
          variant="contained"
          className={`${bgClass} text-white min-w-[120px] relative`}
          onClick={onExit}
          disabled={loading}
          color="inherit"
      >
        <span className={loading ? 'invisible' : ''}>
          {text ?? 'Logout'}
        </span>
        {loading && (
            <CircularProgress size={24} color="inherit" className="absolute left-1/2 top-1/2 -ml-[12px] -mt-[12px]" />
        )}
      </Button>
  );
};

export default StageExitAction;